import { baseApi } from './baseApi';

// A DFO gateway with a secure code; registered ones carry dfo_registered_at/by
export interface DfoGateway {
  device_id: string;
  name: string | null;
  device_mac: string;
  vendor_serial: string;
  secure_code: string;
  secure_serial: string;
  iot_hub_device_id: string;
  dfo_registered_at: string | null;
  dfo_registered_by: string | null;
  dfo_registry_error: string | null;
}

export interface DfoGatewaysResponse {
  configured: boolean;
  data: DfoGateway[];
}

export interface DfoRegisterResponse {
  successful: number;
  failed: number;
}

export const dfoRegistryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDfoGateways: builder.query<DfoGatewaysResponse, void>({
      query: () => '/dfo/gateways',
      providesTags: [{ type: 'DfoGateway', id: 'LIST' }],
    }),

    // Refetch on error too: failures are recorded on each gateway.
    registerDfoGateways: builder.mutation<DfoRegisterResponse, { device_ids: string[] }>({
      query: (body) => ({ url: '/dfo/gateways/register', method: 'POST', body }),
      invalidatesTags: [{ type: 'DfoGateway', id: 'LIST' }],
    }),
  }),
});

export const { useGetDfoGatewaysQuery, useRegisterDfoGatewaysMutation } = dfoRegistryApi;
